;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';

/**
 * This is the wrapper component for a Timeline.
 * Add TimelineElements as its children.
 */
export function Timeline({ children }: { children: ReactNode }): JSX.Element {
  return <Row className="timeline">{children}</Row>;
}

function TimelineContent({ children, right }: { children: ReactNode; right?: boolean }) {
  const textAlign = right ? 'text-start' : 'text-end';
  return (
    <Col sm={5} className={`${textAlign} pt-2`}>
      {children}
    </Col>
  );
}

// Draws a circle around the content, usually a number
const circleBase = {
  borderRadius: '50%',
  border: '2px solid',
  borderColor: 'red',
  background: 'white',
  width: '3em',
  height: '3em',
  minWidth: '3em',
  display: 'inline-block',
};

// Draws a vertical axis down the middle of the background
const axis = (color: string) => ({
  background: `linear-gradient(to right, transparent 50%, ${color} 50% 51%, transparent 50%)`,
});

function TimelineAxis({
  children,
  color = 'red',
  borderRadius = '50%',
  background = 'white',
}: {
  children: ReactNode;
  color?: string;
  borderRadius?: string;
  background?: string;
}) {
  const circle = {
    ...circleBase,
    borderRadius,
    background,
    borderColor: color,
  };
  return (
    <Col sm={2} style={axis(color)} className="timeline-number d-flex justify-content-center align-items-start">
      {/* Only render the circle if there's content for it */}
      {children && (
        <span className="d-flex justify-content-center align-items-center" style={circle}>
          <h2 className="mb-0">{children}</h2>
        </span>
      )}
    </Col>
  );
}

/**
 * A TimelineElement is a single slot in a Timeline.
 * It should always be a <h2> header and a <p> paragraph.
 * Other size headers are allowed but untested.
 */
export function TimelineElement({
  index = '',
  children,
  right,
}: {
  index?: ReactNode;
  children: ReactNode;
  right?: boolean;
}): JSX.Element {
  const classReverse = right ? 'flex-row-reverse' : '';
  return (
    <>
      {/* Layout for larger screens: */}
      <Row className={`${classReverse} d-none d-md-flex`}>
        <TimelineContent right={right}>{children}</TimelineContent>
        <TimelineAxis>{index}</TimelineAxis>
      </Row>
      {/* Layout for mobile screens: */}
      <Row className="d-md-none align-items-center">
        <Col xs={2}>
          <TimelineAxis>{index}</TimelineAxis>
        </Col>
        {children && (
          <>
            <Col xs={10} className="align-items-center">
              {children[0]}
            </Col>
            <Col xs={{ offset: 1, size: 11 }} className="ps-0">
              {children[1]}
            </Col>
          </>
        )}
      </Row>
    </>
  );
}
